import { useQuery } from "react-query";
import { getDVRTypes } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useDVRTypes = () => {
  const { data, isLoading, refetch } = useQuery("GetDVRTypes", getDVRTypes, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
